import { useQuery } from "react-query";
import { getProductionOrders } from "../../../../../services/Production/productionOrderClient";
import moment from "moment/moment";

import ProductionSchedule from "../components/ProductionSchedule";

export default function ProductionSchedulePage() {
  const { data, isError, isLoading } = useQuery(
    ["ProductionOrder"],
    getProductionOrders
  );

  if (isLoading) return <h1>Loading lol</h1>;
  if (data) return <ProductionSchedule events={formatDates(data)} />;
}

function formatDates(events) {
  return events.map((event) => ({
    ...event,
    title: event.code + " " + event.product.name,
    start: moment(new Date(event.scheduledDate)).toDate(),
    end: moment(new Date(event.expectedEndDate)).toDate(),
  }));
}
